
/* styles */
require("!!../../../../.1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../.10.3.0@vue-loader/lib/style-rewriter?id=data-v-547c8773!../../../../.1.2.8@vux-loader/src/after-less-loader.js!less-loader?{'modifyVars':{'header-background-color':'#fff'},'sourceMap':true}!../../../../.1.2.8@vux-loader/src/style-loader.js!../../../../.10.3.0@vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!../../../../.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../.1.2.8@vux-loader/src/script-loader.js!../../../../.10.3.0@vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../../../.10.3.0@vue-loader/lib/template-compiler?id=data-v-547c8773!../../../../.1.2.8@vux-loader/src/template-loader.js!../../../../.10.3.0@vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
require("!!vux-loader/src/noop-loader.js!../../../../.10.3.0@vue-loader/lib/selector?type=customBlocks&index=0!./index.vue")


module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/.2.9.2@vux/src/components/confirm/index.vue
// module id = 186
// module chunks = 17